export default "__VITE_ASSET__CI6YRy_9__"